import { useUpdateFlow } from '../../api/useUpdateFlow'
import { Button, Text } from '@mantine/core'
import { FaultStatus } from '../../api/fault.types'

export function FinishForm({
  id,
  status,
}: {
  id: number
  status?: FaultStatus
}) {
  const { updateFlow } = useUpdateFlow(id)
  return (
    status === FaultStatus.in_progress && (
      <>
        <Button
          mt='md'
          mr='md'
          variant='filled'
          color='teal'
          onClick={() => updateFlow({ flow: 6, decision: 'accepted' })}
        >
          Zakończ naprawę
        </Button>
      </>
    )
  )
}
